import { PERMISSIONS, ROLE_PERMISSIONS_MAP } from '../../constants';

// Permessi universali (concessi a ogni ruolo): non li mostriamo nella matrice
// perché tutte le righe sarebbero piene e l'informazione visiva è nulla.
const HIDDEN_PERMISSIONS = new Set([
  PERMISSIONS.PROFILE_VIEW,
  PERMISSIONS.PROFILE_EDIT,
]);

export const getPermissionsMatrix = () => {
  const roles = Object.keys(ROLE_PERMISSIONS_MAP);
  const permissions = Object.values(PERMISSIONS)
    .filter((p) => !HIDDEN_PERMISSIONS.has(p))
    .sort();
  return Promise.resolve({
    roles,
    permissions,
    matrix: ROLE_PERMISSIONS_MAP,
  });
};
